import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';

/**
 * GH#2765 / GH#2767 — pantalla para lo que todavía no está listo. Sustituye a una pantalla con KPIs en cero y un aviso de error
 * («No se pudo cargar ningún dato del ERP»): quien llega ve la verdad, sin culpa y sin nada roto.
 * Contraste de los botones: blanco sobre primary-700 (5,85:1; sobre primary-600 daría 4,10:1) y texto gris-900 sobre blanco.
 */
export interface ServicioNoDisponibleProps {
  titulo?: string;
  descripcion?: string;
  /** Acción secundaria, p. ej. «Reintentar». */
  accion?: { texto: string; onClick: () => void };
  /** Enlace secundario a OTRO sitio (sale de la app), p. ej. el sitio oficial mientras el portal no está listo. */
  enlace?: { texto: string; href: string };
}

export function ServicioNoDisponible({
  titulo = 'Esta función todavía no está disponible',
  descripcion = 'La estamos terminando de preparar. Cuando esté lista aparecerá en tu menú. Mientras tanto, el resto de InboMarket sigue funcionando con normalidad.',
  accion,
  enlace,
}: ServicioNoDisponibleProps) {
  return (
    <section aria-labelledby="servicio-no-disponible-titulo" className="mx-auto flex max-w-lg flex-col items-center px-6 py-20 text-center">
      <Clock aria-hidden="true" className="h-10 w-10 text-gray-400" />
      <h1 id="servicio-no-disponible-titulo" className="mt-4 text-xl font-semibold text-gray-900">
        {titulo}
      </h1>
      <p className="mt-2 text-sm text-gray-600">{descripcion}</p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        {accion && (
          <button
            type="button"
            onClick={accion.onClick}
            className="inline-flex min-h-[44px] items-center rounded-lg border border-gray-300 bg-white px-4 text-sm font-medium text-gray-900 hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-700"
          >
            {accion.texto}
          </button>
        )}
        {enlace && (
          <a
            href={enlace.href}
            className="inline-flex min-h-[44px] items-center rounded-lg border border-gray-300 bg-white px-4 text-sm font-medium text-gray-900 hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-700"
          >
            {enlace.texto}
          </a>
        )}
        <Link
          to="/"
          className="inline-flex min-h-[44px] items-center rounded-lg bg-primary-700 px-4 text-sm font-medium text-white hover:bg-primary-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-700"
        >
          Volver al inicio
        </Link>
      </div>
    </section>
  );
}
